import { SubmitIconButtonBase } from "@compass/core";
import { ButtonProps as MuiButtonProps } from "@mui/material";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

export const SubmitIconButton = (
  props: MuiButtonProps & {
    disabled?: boolean;
  }
) => {
  const appLoading = useSelector((state: RootState) => state.app.loading);
  const disabledOnLoading = appLoading > 0; // submit button needs to be disabled when loading

  const { disabled, ...rest } = props;
  return <SubmitIconButtonBase disabled={disabledOnLoading || disabled} {...rest} />;
};
